module.exports = __webpack_public_path__ + "static/media/Gregory.0c284583.png";